export const getStringValue = (value: string | null) => {
  return value ? value.toString().toLowerCase() : ''
}
